/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MailTemplateVariableObjectFromJSON, MailTemplateVariableObjectToJSON } from './MailTemplateVariableObject';
export function VariablesMailTemplateResponseDataFromJSON(json) {
    return VariablesMailTemplateResponseDataFromJSONTyped(json, false);
}
export function VariablesMailTemplateResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        mailTemplateVariableObjects: !exists(json, 'mail_template_variable_objects')
            ? undefined
            : json['mail_template_variable_objects'].map(MailTemplateVariableObjectFromJSON)
    };
}
export function VariablesMailTemplateResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        mail_template_variable_objects: value.mailTemplateVariableObjects === undefined
            ? undefined
            : value.mailTemplateVariableObjects.map(MailTemplateVariableObjectToJSON)
    };
}
